import * as React from 'react';
import styles from './index.less';
import * as ReactDOM from 'react-dom/client';
import FBatchHandleResource_ResultModal from './FBatchHandleResource_ResultModal';

interface fBatchHandleResource_ResultModal_Props {
  type: 'online' | 'offline' | 'addPolicy' | 'signNode';
  dataSource: {
    [k: string]: {
      data: string;
      status: 1 | 2;
    };
  };
}

function fBatchHandleResource_ResultModal({ type, dataSource }: fBatchHandleResource_ResultModal_Props): Promise<null> {
  return new Promise<null>((resolve) => {
    const divRoot = self.document.body;
    const div = self.document.createElement('div') as HTMLDivElement;
    divRoot.appendChild(div);
    const root = ReactDOM.createRoot(div);
    return root.render(<FBatchHandleResource_ResultModal
      type={type}
      dataSource={dataSource}
      onClose={() => {
        setTimeout(() => {
          resolve(null);
          root.unmount();
          div.remove();
        }, 1);
      }}
    />);
  });
}

export default fBatchHandleResource_ResultModal;
